import { useEffect, useState } from 'react';
import { useAdminsStore } from 'views/store/useAdminsStore';
import { adminService } from 'views/services/adminService';
import { formatRoleName } from 'utils/formatRoleName';

const statuses = ['active', 'inactive'];
const onlineOptions = [
  { label: 'Online', value: true },
  { label: 'Offline', value: false },
];

interface AdminsFilterDropdownProps {
  disabled?: boolean;
}

export const AdminsFilterDropdown = ({
  disabled = false,
}: AdminsFilterDropdownProps) => {
  const { filters, setFilters } = useAdminsStore();
  const [roles, setRoles] = useState<
    { id: string; name: string; description: string }[]
  >([]);

  useEffect(() => {
    const loadRoles = async () => {
      const rolesData = await adminService.getRoles();
      setRoles(rolesData);
    };
    loadRoles();
  }, []);

  const handleChange = (
    field: 'role' | 'status' | 'online',
    value: string | boolean
  ) => {
    const newFilters = {
      ...filters,
      [field]: value === '' ? undefined : value,
    };
    setFilters(newFilters);
  };

  return (
    <div className="flex flex-col gap-2 md:flex-row px-2">
      <select
        className="w-[130px] rounded-lg border p-2 bg-white dark:bg-navy-900 text-navy-700 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed"
        value={filters.role || ''}
        onChange={e => handleChange('role', e.target.value)}
        disabled={disabled}
      >
        <option value="">All Roles</option>
        {roles.map(role => (
          <option key={role.id} value={role.name}>
            {formatRoleName(role.name)}
          </option>
        ))}
      </select>

      <select
        className="w-[130px] rounded-lg border p-2 bg-white dark:bg-navy-900 text-navy-700 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed"
        value={filters.status || ''}
        onChange={e => handleChange('status', e.target.value)}
        disabled={disabled}
      >
        <option value="">All Statuses</option>
        {statuses.map(status => (
          <option key={status} value={status}>
            {status[0].toUpperCase() + status.slice(1)}
          </option>
        ))}
      </select>

      <select
        className="w-[130px] rounded-lg border p-2 bg-white dark:bg-navy-900 text-navy-700 dark:text-white disabled:opacity-50 disabled:cursor-not-allowed"
        value={
          filters.online === undefined ? '' : filters.online ? 'true' : 'false'
        }
        onChange={e =>
          handleChange(
            'online',
            e.target.value === '' ? undefined : e.target.value === 'true'
          )
        }
        disabled={disabled}
      >
        <option value="">All Statuses</option>
        {onlineOptions.map(opt => (
          <option key={String(opt.value)} value={String(opt.value)}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
